import { useQuery } from "../client.ts";

const POLLING_INTERVAL_MS = 5000;

interface UsePollOverviewQueryOptions {
    enabled?: boolean;
    isPolling?: boolean;
}

export function usePollOverviewQuery({ enabled = true, isPolling = true }: UsePollOverviewQueryOptions = {}) {
    return useQuery("get", "/bff/migrate/microsoft/assessments/v2/getAssessment", undefined, {
        enabled,
        refetchInterval: query =>
            isPolling && query.state.data?.isPollingRequired !== false ? POLLING_INTERVAL_MS : false
    });
}
